export interface ShareRecipient {
    clientId: string;
    expiryDays: number;
}

export interface ShareExpiryPreset {
    days: number;
    labelKey: string;
}

export const SHARE_EXPIRY_DEFAULT_DAYS = 7;

export const SHARE_EXPIRY_PRESETS: readonly ShareExpiryPreset[] = [
    { days: 1, labelKey: 'features.workPackages.upload.share.expiry.presets.day1' },
    { days: 3, labelKey: 'features.workPackages.upload.share.expiry.presets.day3' },
    { days: 7, labelKey: 'features.workPackages.upload.share.expiry.presets.day7' },
    { days: 30, labelKey: 'features.workPackages.upload.share.expiry.presets.day30' },
];
